import axios from 'axios'
import router from '../router'
const request = axios.create({
  baseURL: '/api',
  timeout: 10000,
  withCredentials: true
})

// 全局响应拦截：未登录时强制跳转登录页
request.interceptors.response.use(
  (response) => {
    const data = response && response.data;
    const url = (response && response.config && response.config.url) || '';
    // 登录/注册接口不做未登录跳转处理
    if (url.includes('/user/login') || url.includes('/user/register')) {
      return response;
    }
    if (data && data.code !== 200) {
      const msg = data.message || '';
      if (msg.includes('未登录') || msg.includes('请先登录')) {
        router.push('/login');
        return Promise.reject(new Error('未登录'));
      }
    }
    return response;
  },
  (error) => {
    if (error && error.response && error.response.status === 401) {
      router.push('/login');
    }
    return Promise.reject(error);
  }
);

export const addTask = (data) => {
  return request.post('/task/add', data)
}

export const getAllTasks = () => {
  return request.get('/task/list')
}

// 批量添加重复任务
export const batchAddRepeatTasks = (data) => {
  return request.post('/task/batch-repeat', data, { timeout: 60000 })
}

// 批量添加重复任务 - 试算预览（不落库）
export const previewBatchRepeat = (data) => {
  return request.post('/task/batch-repeat/preview', data)
}

export const getTasksByPage = (page, pageSize) => {
  return request.get('/task/page', { params: { page, pageSize } })
}

export const getDailyTasks = (date) => {
  return request.get('/task/daily', { params: { date } })
}

export const updateTaskStatus = (id, status) => {
  return request.put(`/task/update/${id}`, null, { params: { status } })
}

export const editTask = (id, data) => {
  return request.put(`/task/edit/${id}`, data)
}

export const deleteTask = (id) => {
  return request.delete(`/task/delete/${id}`)
}

export const scheduleTask = (id, date) => {
  return request.put(`/task/schedule/${id}`, null, { params: { date } })
}

export const rolloverTasks = () => {
  return request.post('/task/rollover')
}

// 分析任务负载，检测是否需要加班
export const analyzeWorkload = () => {
  return request.get('/task/analyze-workload')
}

// 生成周计划
export const generateWeeklyPlan = (overtime = false) => {
  return request.post('/task/generate-weekly-plan', null, {
    params: { overtime },
    timeout: 180000
  })
}

// 开始任务计时
export const startTask = (id) => {
  return request.post(`/task/start/${id}`)
}

// 完成任务并记录用时
export const completeTask = (id) => {
  return request.post(`/task/complete/${id}`)
}
